import {Column, ColumnGrid} from "../../../ui/spectre/grid";
import translate from "../../../../../translate";
import React from "react";
import {RichTableHeader} from "../../../tableUtils/richTableContainer";

export default function IncomingAttackListHeader() {
    return <ColumnGrid className={'defaultTableHeader'}>
        <Column sizes={[1, null, 2]}>
            <RichTableHeader sortType={Number} sortColumn={'attackerSid'} filterColumn={'attackerSid'}>{translate('tool/trav/22/attackingPlayer')}</RichTableHeader>
        </Column>
        <Column sizes={[1, null, 2]}>
            <RichTableHeader sortType={Number} sortColumn={'attackerDid'} filterColumn={'attackerDid'}>{translate('tool/trav/22/attackingVillage')}</RichTableHeader>
        </Column>
        <Column sizes={[1, null, 2]}>
            <RichTableHeader sortType={Number} sortColumn={'defenderSid'} filterColumn={'defenderSid'}>{translate('tool/trav/22/defendingPlayer')}</RichTableHeader>
        </Column>
        <Column sizes={[1, null, 2]}>
            <RichTableHeader sortType={Number} sortColumn={'defenderDid'} filterColumn={'defenderDid'}>{translate('tool/trav/22/defendingVillage')}</RichTableHeader>
        </Column>
        <Column sizes={[1, null, 2]}>
            <RichTableHeader sortType={Number} sortColumn={'arrivalTime'}>{translate('tool/trav/22/remainingTime')}</RichTableHeader>
        </Column>
        <Column sizes={[1, null, 2]}>
            <RichTableHeader sortType={Number} sortColumn={'arrivalTime'}>{translate('tool/trav/22/arrivalTime')}</RichTableHeader>
        </Column>
        <Column sizes={[2, null, 4]}>
            <RichTableHeader sortType={Number} sortColumn={'baseSpeed'} filterColumn={'baseSpeed'}>{translate('tool/trav/22/speedInfo')}</RichTableHeader>
        </Column>
        <Column sizes={[1, null, 2]}>
            <RichTableHeader sortType={Number} sortColumn={'classification'} filterColumn={'classification'}>{translate('tool/trav/22/classification')}</RichTableHeader>
        </Column>
        <Column sizes={[1, null, 2]}>
            <RichTableHeader sortType={Number} sortColumn={'comment'} filterColumn={'comment'}>{translate('tool/trav/22/comment')}</RichTableHeader>
        </Column>
        <Column sizes={[1, null, 2]}>{translate('tool/trav/22/actions')}</Column>
    </ColumnGrid>
}
